<template>
    <div class="pt-2">
        <div
            class="flex items-center gap-[8px] py-[6px] text-[14px] leading-[20px] text-gray-800"
            data-testid="sms-ai-error-alert"
            v-if="isFailed"
        >
            <icon class="h-[16px] w-[16px] shrink-0 text-red-600" name="bold/alert-circle" />
            <span>
                {{ $t('smsCommunication.aiDraft.error') }}
                <a class="text-blue-500" href="mailto:support@activix.ca">support@activix.ca</a>.
            </span>
        </div>

        <div
            class="flex items-center gap-[8px] py-[6px] text-[14px] leading-[20px] text-gray-800"
            data-testid="sms-ai-rate-limit-alert"
            v-if="isRateLimited"
        >
            <icon class="h-[16px] w-[16px] shrink-0 text-orange-500" name="bold/alert-circle" />
            <i18n-t keypath="smsCommunication.aiDraft.rateLimit" tag="span">
                <template #emphasis>
                    <span class="font-semibold" data-testid="sms-ai-rate-limit-emphasis">{{
                        $t('smsCommunication.aiDraft.rateLimitEmphasis', {
                            seconds: rateLimitSeconds,
                        })
                    }}</span>
                </template>
            </i18n-t>
        </div>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        isFailed: boolean;
        isRateLimited: boolean;
        rateLimitSeconds: number;
    }>();
</script>
